import React, { useEffect } from 'react';

const CountdownScreen = ({ countdown, onNext }) => {


  useEffect(() => {
    let cancelled = false;
    const playSeq = async () => {
      try {
        const play = async (file) => {
          const audio = new Audio(`/audio/${file}`);
          await audio.play();
          await new Promise((r) => audio.addEventListener('ended', r, { once: true }));
        };
        await play('321.mp3');
        if (!cancelled) onNext();
      } catch (e) {
        // If autoplay blocked, show READY button fallback
        // No-op here; user can click READY
      }
    };
    playSeq();
    return () => { cancelled = true; };
  }, [onNext]);

  return (
    <div className="content-area">
      {/* Countdown display */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        gap: '50px',
      }}>
        <div className="text-large">
          {countdown}
        </div>
      </div>
    </div>
  );
};

export default CountdownScreen;
